import { Container } from "react-bootstrap";
import { Outlet } from "react-router-dom";

const AuthLayout = ({ children }) => {
  return (
    <Container
      fluid
      className="d-flex h-100vh justify-content-center align-items-center dark-background"
    >
      {children}
      <Outlet />
    </Container>
  );
};

export default AuthLayout;
